import CryptoJS from 'crypto-js';
import { Capacitor } from '@capacitor/core';

export const ApiAuthPlugin = {
  install(Vue, { store }) {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isNative = Capacitor.isNativePlatform();
    store.commit('general/setIsMobileApp', isNative || userAgent.includes('Mobile App'));

    Vue.gtm.push({
      client_device_type: isNative
        ? 'mobile_app'
        : /android|ipad|iphone|ipod|ios/i.test(userAgent)
        ? 'web_responsive'
        : 'desktop'
    });

    const checkFlutterInterval = window.setInterval(() => {
      if (window.isFlutterReady) {
        store.dispatch('flutter/setIsFlutterReady', true);
        window.clearInterval(checkFlutterInterval);
      }
    }, 500);

    const apiKey = import.meta.env.VITE_API_KEY_APP;

    Object.keys(Vue.prototype.$graphql).forEach(clientKey =>
      Vue.prototype.$graphql[clientKey].setHeader('X-Api-Key', apiKey)
    );

    if (!store.state.apiToken.token) {
      const partnerHash = CryptoJS.MD5(
        import.meta.env.VITE_PRIVATE_KEY + Math.floor(Date.now() / 60)
      ).toString();

      store
        .$refreshXApiToken(
          {
            post: async (url, data, config) => {
              const result = await store.$http.post(url, data, config);
              return { status: 200, data: result };
            }
          },
          {
            partnerId: 0,
            partnerHash,
            partnerClientId: import.meta.env.VITE_PARTNER_CLIENT_ID
          },
          () => {
            Object.keys(Vue.prototype.$graphql).forEach(clientKey =>
              Vue.prototype.$graphql[clientKey].setHeader('X-Api-Token', store.state.apiToken.token)
            );
          }
        )
        .catch(err => {
          return err;
        });
    }
  }
};
